module.exports = __webpack_public_path__ + "media/images/states/mn-red-3263769ec201217489f8483c519ff12a.png";